import { css } from "emotion";
import { Component } from "preact";
import React from "react";
import CMSComponent from "../../components/CMSComponent";
import H2 from "../../components/global/H2";
import H4 from "../../components/global/H4";
import MoreButton from "../../components/global/MoreButton";
import P from "../../components/global/P";
import Image from "../../components/Image";
import ContentBlock from "../../components/layout/ContentBlock";
import Layout from "../../components/layout/Layout";
import ColorServices from "../../services/ColorServices";
import { updateTitle } from "../../utils/BrowserUtils";
import { max } from "../../utils/CssUtils";

const organiserSupport = require("../../assets/ic_organiser_support.svg");
const buyerSupport = require("../../assets/ic_buyer_support.svg");
const generalSupport = require("../../assets/ic_general_support.svg");

const wrapper = css({
  textAlign: "center",
  h2: {
    fontSize: 36,
    marginBottom: 16
  },
  p: {
    fontSize: 18,
    marginBottom: 56
  },
  "@media(max-width: 900px)": {
    padding: "0px 14px"
  },
  [max(768)]: {
    h2: {
      fontSize: 22
    }
  }
});
const blockLink = css({
  display: "block",
  paddingTop: 24,
  "&:hover": {
    textDecoration: "none"
  }
});
const moreLink = css({
  "&:hover": {
    textDecoration: "none",
    boxShadow: "0 3px 10px 0 rgba(9, 30, 66, 0.13)"
  }
});
const links = css({
  display: "flex",
  justifyContent: "space-between",
  maxWidth: 872,
  margin: "0 auto",
  div: {
    minWidth: 280,
    minHeight: 248,
    border: `1px ${ColorServices.getColor("purple")} solid`,
    backgroundColor: ColorServices.getColor("white"),
    borderRadius: 4,
    paddingBottom: "24px",
    textAlign: "center",
    img: {
      height: 80,
      marginBottom: 16
    },
    "&:hover": {
      boxShadow: "0 3px 10px 0 rgba(9, 30, 66, 0.13)"
    },
    h4: {
      marginBottom: 8
    },
    p: {
      marginBottom: 24
    }
  },
  "@media(max-width: 900px)": {
    div: {
      marginBottom: 24
    }
  }
});

class ContactUs extends Component {
  componentDidMount() {
    updateTitle("Contact Us");
  }

  render() {
    const { locale } = this.props;
    return (
      <Layout>
        <ContentBlock color="grey" sidePad={false}>
          <div className={wrapper}>
            <H2>Contact Us</H2>
            <P>Some of our humans will get back to you shortly</P>
            <div className={links}>
              <div>
                <a
                  className={blockLink}
                  href={`/${locale}/contact-us/buyer-support`}
                  aria-label="Buyer Support Link"
                >
                  <Image imageURL={buyerSupport} alt="" />
                  <H4>Buyer Support</H4>
                  <P>For attendees of live events</P>
                </a>
                <span className={moreLink}>
                  <MoreButton
                    className={moreLink}
                    path="/contact-us/buyer-support"
                    locale={locale}
                    label="Contact us"
                  />
                </span>
              </div>
              <div>
                <a
                  className={blockLink}
                  href={`/${locale}/contact-us/organiser-support`}
                  aria-label="Organiser Support Link"
                >
                  <Image imageURL={organiserSupport} alt="" />
                  <H4>Organiser Support</H4>
                  <P>For organisers hosting events</P>
                </a>
                <span className={moreLink}>
                  <MoreButton
                    path="/contact-us/organiser-support"
                    locale={locale}
                    label="Contact us"
                  />
                </span>
              </div>
              <div>
                <a
                  className={blockLink}
                  href={`/${locale}/contact-us/general-support`}
                  aria-label="General Support Link"
                >
                  <Image imageURL={generalSupport} alt="" />
                  <H4>General Support</H4>
                  <P>For other requests</P>
                </a>
                <span className={moreLink}>
                  <MoreButton
                    path="/contact-us/general-support"
                    locale={locale}
                    label="Contact us"
                  />
                </span>
              </div>
            </div>
          </div>
        </ContentBlock>
      </Layout>
    );
  }
}

export default CMSComponent(null, ContactUs);
